import { render } from "./SfjcSetDialog.vue?vue&type=template&id=63decc78&scoped=true"
import script from "./SfjcSetDialog.vue?vue&type=script&lang=js"
export * from "./SfjcSetDialog.vue?vue&type=script&lang=js"

import "./SfjcSetDialog.vue?vue&type=style&index=0&id=63decc78&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63decc78"]])

export default __exports__